import React, { Component } from 'react'

class Faqs extends Component {

  state = {
    items: false,
    accordionOpen: false,
  }

  componentDidMount() {
    this._showCategory(0)
  }

  _showCategory = (key) => {
    let items = [];
    items[key] = true
    this.setState({ items })
  }

  _toggleAccordion = (accordionItem) => {
    this.setState({accordionOpen: {[accordionItem]: !this.state.accordionOpen[accordionItem]} })
  }

  render() {

    let { title, categories } = this.props
    let { items, accordionOpen } = this.state

    return (
      <section className='faqs'>
        <div className='faqs__inner'>
          <div className='faqs__title'>
            <h3>{title}</h3>
            { categories && 
              <ul className='faqs__list'>
                { categories.map((el, i) => (
                  <li className={`faqs__list-item ${items[i] ? 'active' : ''}`} key={i}>
                    <button type='button' onClick={() => this._showCategory(i)}>{el.title}</button>
                  </li>
                ))}
              </ul>
            }
          </div>
          <div className='faqs__content'>
            { categories && 
              <div className='faqs__categories'>
                { categories.map((el, i) => (
                  <div className={`faqs__category ${items[i] ? 'active' : ''}`} key={i}>
                    <div className='accordion'>
                      { el.items.map((acc, a) => (
                        <div className={accordionOpen[a] ? 'accordion__item active' : 'accordion__item'} key={a}>
                          <h4 className='accordion__title' onClick={() => this._toggleAccordion(a)}>
                            <span className='title'>{acc.question}</span>
                            <span className='arrow' />
                          </h4>
                          <div className='accordion__content'>
                            <div dangerouslySetInnerHTML={{ __html: acc.answer }} />
                          </div>  
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            }
            <div className='faqs__disclaimer'>
              <p>The information provided on this page is for ease of reference only and is not intended to be relied on as legal or financial advice. In all circumstances, we recommend that you seek independent legal and/or financial advice to ensure that you are fully informed in relation to the risks and obligations associated with a relevant transaction.</p>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Faqs
